var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.032,
    height: 11.139,
    viewBox: "0 0 9.032 11.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-35 -31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(35 31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M35.9,42.139a.3.3,0,0,1-.3-.3v-8.43a.3.3,0,0,1,.3-.3h7.225a.3.3,0,0,1,.3.3v8.43a.3.3,0,0,1-.3.3Zm6.924-.6V33.71H36.2v7.828Zm.9-9.935a.3.3,0,0,1,.3.3v1.505a.3.3,0,0,1-.3.3H35.3a.3.3,0,0,1-.3-.3V31.9a.3.3,0,0,1,.3-.3h1.983l.514-.514A.3.3,0,0,1,38.011,31h3.011a.3.3,0,0,1,.213.088l.514.514Zm-2.107.6a.3.3,0,0,1-.213-.088L40.9,31.6H38.135l-.514.514a.3.3,0,0,1-.213.088H35.6v.9H43.43v-.9Z",
    transform: "translate(-35 -31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M43,43.8v5.118a.3.3,0,1,0,.6,0V43.8a.3.3,0,0,0-.6,0Z",
    transform: "translate(-40.592 -39.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M49,43.8v5.118a.3.3,0,1,0,.6,0V43.8a.3.3,0,1,0-.6,0Z",
    transform: "translate(-44.785 -39.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M55,43.8v5.118a.3.3,0,1,0,.6,0V43.8a.3.3,0,1,0-.6,0Z",
    transform: "translate(-48.979 -39.737)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAvatar);
export default __webpack_public_path__ + "static/media/delete_avatar.996f038bb60a89dcc7b0decedde9a686.svg";
export { ForwardRef as ReactComponent };